import { ref } from "vue";
import { defineStore } from "pinia";

const IGNORED_WARNINGS_KEY = "ignored-warnings";

export const useIgnoreWarnings = defineStore("ignore-warnings-store", () => {
    const ignoredWarnings = ref(
        JSON.parse(localStorage.getItem(IGNORED_WARNINGS_KEY) || "{}")
    );

    const saveWarningsState = () => {
        localStorage.setItem(IGNORED_WARNINGS_KEY, JSON.stringify(ignoredWarnings.value))
    }

    const ignoreWarning = (resumeId, warningId) => {
        if(warningId != null && resumeId != null) {
            ignoredWarnings.value[resumeId] = [...ignoredWarnings.value?.[resumeId] || [], warningId]
            saveWarningsState()
        }
    }

    const warningIsIgnored = (resumeId, warningId) => {
        return ignoredWarnings.value?.[resumeId]?.includes(warningId) || false
    }

    return {
        ignoredWarnings,
        ignoreWarning,
        warningIsIgnored
    };
});
